import { useState } from 'react';
import { TableIcon } from 'nexticons/outline';
import {
  ButtonUI,
  LayoutPartUI,
  ScrollableBoxUI,
  CircleCloseButtonUI,
  InputUI,
} from '@next-order/next-order-components';

const ConfirmTable = ({ confirmTable, hideModal }) => {
  const [tableNo, setTableNo] = useState('');

  return (
    <>
      <div className='w-full z-[99998] h-full bg-[#e1e1e1] opacity-75 absolute top-0 left-0 visible-xs visible-sm' />
      <div className='dinein fixed z-[99999] bottom-0 left-0 w-full h-auto visible-xs visible-sm'>
        <LayoutPartUI extendedClassName='overflow-hidden rounded-t-6.75 max-h-95.5 h-full w-full bg-white'>
          <LayoutPartUI.Header extendedClassName='pt-4.75 pb-5'>
            <LayoutPartUI.Row>
              <CircleCloseButtonUI
                size='2xl'
                extendedClassName='outline-0'
                onClick={hideModal}
              />
            </LayoutPartUI.Row>
          </LayoutPartUI.Header>
          <LayoutPartUI.Body paddingX='none'>
            <ScrollableBoxUI
              paddingX='lg'
              extendedClassName='pt-2 pb-5 -2xs:px-5'
            >
              <LayoutPartUI.Row extendedClassName='mb-11'>
                <h3 className='text-2xl 2xs:text-7.25 font-medium tracking-tight leading-tight'>
                  What’s your table number?
                </h3>
              </LayoutPartUI.Row>
              <LayoutPartUI.Row extendedClassName='relative'>
                <TableIcon
                  width={28}
                  className='absolute left-7 top-1/2 -translate-y-1/2 -translate-x-1/2 text-gray-500'
                />
                <InputUI
                  autoFocus
                  name='table_number'
                  placeholder='Enter Table Number'
                  size='xl'
                  value={tableNo}
                  onChange={(e) => {
                    setTableNo(e.target.value);
                  }}
                  type='number'
                  extendedClassName='outline-0 focus:outline-0 shadow-cw pl-14.25'
                />
              </LayoutPartUI.Row>
            </ScrollableBoxUI>
          </LayoutPartUI.Body>
          <LayoutPartUI.Footer
            extendedClassName='pt-5 pb-5.5 -2xs:px-5'
            paddingX='lg'
          >
            <ButtonUI
              fullWidth
              size='xl'
              rounded='xl'
              extendedClassName='2xs:min-h-12.25 2xs:text-lg outline-0'
              disabled={!tableNo}
              onClick={() => confirmTable(tableNo)}
            >
              Confirm Table {tableNo}
            </ButtonUI>
          </LayoutPartUI.Footer>
        </LayoutPartUI>
      </div>
    </>
  );
};

export default ConfirmTable;
